'use client';

import { Shift } from '@/lib/types';
import { formatDateDisplay, formatTimeForDisplay } from '@/lib/date-utils';

interface Props {
  shifts: Shift[];
}

export default function ShiftTable({ shifts }: Props) {
  if (shifts.length === 0) {
    return <p className="text-zinc-500">No shifts found for this person.</p>;
  }

  const sorted = [...shifts].sort((a, b) => a.date.getTime() - b.date.getTime());

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-zinc-200 dark:border-zinc-700">
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Date</th>
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Day</th>
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Time</th>
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Shift</th>
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Location</th>
            <th className="text-left py-2 px-3 text-zinc-600 dark:text-zinc-400">Type</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((shift, i) => (
            <tr key={i} className="border-b border-zinc-100 dark:border-zinc-800">
              <td className="py-2 px-3 text-zinc-800 dark:text-zinc-200">
                {formatDateDisplay(shift.date)}
              </td>
              <td className="py-2 px-3 text-zinc-600 dark:text-zinc-400">
                {shift.date.toLocaleDateString('en-AU', { weekday: 'short' })}
              </td>
              <td className="py-2 px-3 text-zinc-800 dark:text-zinc-200">
                {shift.type === 'shift' && shift.startTime
                  ? `${formatTimeForDisplay(shift.startTime)} - ${formatTimeForDisplay(shift.endTime)}${shift.isOvernight ? ' +1' : ''}`
                  : 'All day'}
              </td>
              <td className="py-2 px-3 text-zinc-800 dark:text-zinc-200">{shift.label}</td>
              <td className="py-2 px-3 text-zinc-600 dark:text-zinc-400">{shift.location}</td>
              <td className="py-2 px-3">
                <span
                  className={`px-2 py-0.5 rounded text-xs ${
                    shift.type === 'shift'
                      ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
                      : shift.type === 'leave'
                      ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                      : 'bg-zinc-100 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-300'
                  }`}
                >
                  {shift.type}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}